import View from './Vertical'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const Vertical = connect(mapStateToProps)(View)

export default Vertical
